import { configureStore } from '@reduxjs/toolkit';
import authReducer from './user/authSlice';
import calendarReducer from './calendar/calendarSlice';
import modalReducer from './modal/modalSlice';
import cardsReducer from './court/courtSlice';
import inventoryReducer from './inventory/inventorySlice';
import navbarReducer from '../store/navbar/navbarSlice';
import settingsReducer from './gettingStarted/settingsComplete';
import trainersReducer from './trainer/trainerSlice';
import completedSettingsReducer from './getStartedSettings/getStartedSettings';
import clientsReducer from './client/clientSlice';
import clubReducer from './club/clubSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import adminsReducer from './admin/adminSlice';
import { combineReducers } from 'redux';
import worksTrainerReducer from './worksTrainer/trainerAvailabilitySlice';
import scheduleWorkReducer from './scheduleWork/scheduleSlice';
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'settings', 'completedSettings', 'club'],
  // whitelist: ['auth', 'club'],
};

const rootReducer = combineReducers({
  schedule: scheduleWorkReducer,
  auth: authReducer,
  calendar: calendarReducer,
  modal: modalReducer,
  cards: cardsReducer,
  inventory: inventoryReducer,
  navbar: navbarReducer,
  settings: settingsReducer,
  trainers: trainersReducer,
  completedSettings: completedSettingsReducer,
  clients: clientsReducer,
  club: clubReducer,
  admins: adminsReducer,
  worksTrainers: worksTrainerReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // Опционально: middleware, если нужно (например, для избежания ошибок сериализации)
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PURGE',
          'persist/FLUSH',
          'persist/PAUSE',
          'persist/REHYDRATE',
          'persist/PERSIST',
        ],
      },
    }),
});

export const persistor = persistStore(store);
